import React from 'react'
import MenuContext from 'widgets/navigation/MenuContext'
import { useEventListeners } from '@morningtrain/react-helpers'

export default function MenuItemWrapper ({ children }) {

  const menuItemsRef = React.useRef({})
  const menuItems = menuItemsRef.current

  const [triggerOnActiveMenuChange, onActiveMenuChange] = useEventListeners()

  const menu = {}

  menu.addMenu = (uuid, menuItem) => {
    menuItems[uuid] = menuItem

    return () => menu.removeMenu(uuid)
  }

  menu.removeMenu = (uuid) => {
    if (menuItems[uuid]) {
      delete menuItems[uuid]
    }
  }

  menu.setActive = (uuid) => {
    triggerOnActiveMenuChange(uuid, true)
  }

  menu.onActiveMenuChange = onActiveMenuChange

  return (
    <MenuContext.Provider value={menu}>
      {children}
    </MenuContext.Provider>
  )
}
